import { useMemo } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentProject } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLink from "ds/components/Table/Row/CellLink";

import useCellCopyAction from "../useCellCopyAction";

const IntentProjectsTableNameCell = ({
  item: intentProject,
  ...cellProps
}: TableSimpleCellProps<IntentProject>) => {
  const intentProjectUrl = `/intent-project/${intentProject.id}`;

  const copyAction = useCellCopyAction({
    text: intentProject.name,
  });

  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <TableSimpleCell {...cellProps} role="rowheader" actions={actions}>
      <TableCellLink href={intentProjectUrl}>{intentProject.name}</TableCellLink>
    </TableSimpleCell>
  );
};

export default IntentProjectsTableNameCell;
